import React from 'react';

import {HydratedFeatureCollection} from 'app/modules/Remote/FeatureCollection';

import {GeometryOverlayContent} from './GeometryOverlaysContent';

export interface QuickMapVectorLayer {
  id: number;
  originalFileName?: string;
  hfc: HydratedFeatureCollection;
  outlineColor: string;
  isVisible: boolean;
}

const QuickMapVectorLayers: React.FunctionComponent<
  React.PropsWithChildren<{
    map: mapboxgl.Map;
    isMapLoaded: boolean;
    layers: QuickMapVectorLayer[];
  }>
> = ({map, isMapLoaded, layers}) => (
  <>
    {layers.map((layer) => (
      <GeometryOverlayContent
        key={layer.id}
        map={map}
        isMapLoaded={isMapLoaded}
        hydratedFeatureCollection={layer.hfc}
        color={layer.outlineColor}
        isVisible={layer.isVisible}
        defaultFilled={true}
        defaultUnfilled={false}
        //TODO: could add the optional onClick prop if we wanted to edit, etc
      />
    ))}
  </>
);

export default QuickMapVectorLayers;
